let pConLoadedTimeout = false,
    lastOpenedPconKey = null,
    activeOfferTippyInstance = null,
    swipers = {
        alternatives: {
            slider: false,
            elem: $('.js-alternatives-slider'),
            active: false,
            query: false,
            tooltipOpen: false,
            options: {
                loop: false,
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 16,
                simulateTouch: false,
                speed: 400,
                watchOverflow: true,
                roundLengths: true,
                pagination: {
                    el: '.js-alternatives-slider-dots',
                    clickable: true
                },
                navigation: {
                    nextEl: '.js-alternatives-slider-next',
                    prevEl: '.js-alternatives-slider-prev',
                    disabledClass: 'is-disabled',
                    hiddenClass: 'is-hidden'
                },
                breakpoints: {
                    359: {
                        spaceBetween: 6,
                        slidesPerView: 1.2,
                        slidesPerGroup: 1
                    },
                    599: {
                        spaceBetween: 10,
                        slidesPerView: 1.4,
                        slidesPerGroup: 1
                    },
                    767: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    1023: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    }
                },
                on: {
                    init: function () {
                        swipers.alternatives.active = true;
                    },
                    slideChange: function () {
                        setTimeout(function () {
                            bLazy.revalidate()
                        }, 300);
                    }
                }
            }
        },
        accessories: {
            slider: false,
            elem: $('.js-accessories-slider'),
            active: false,
            query: false,
            tooltipOpen: false,
            options: {
                loop: false,
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 16,
                simulateTouch: false,
                speed: 400,
                watchOverflow: true,
                roundLengths: true,
                pagination: {
                    el: '.js-accessories-slider-dots',
                    clickable: true
                },
                navigation: {
                    nextEl: '.js-accessories-slider-next',
                    prevEl: '.js-accessories-slider-prev',
                    disabledClass: 'is-disabled',
                    hiddenClass: 'is-hidden'
                },
                breakpoints: {
                    359: {
                        spaceBetween: 6,
                        slidesPerView: 1.2,
                        slidesPerGroup: 1
                    },
                    599: {
                        spaceBetween: 10,
                        slidesPerView: 1.4,
                        slidesPerGroup: 1
                    },
                    767: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    1023: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    }
                },
                on: {
                    init: function () {
                        swipers.accessories.active = true;
                    },
                    slideChange: function () {
                        setTimeout(function () {
                            bLazy.revalidate()
                        }, 300);
                    }
                }
            }
        }
    };

rEvent.on('Window.resized', function () {
    checkSliders(swipers);
});

Spinner.template = "{{value}} {{append}}";

Form.buildSpinners = function () {
    Form.buildSpinnersInside('body');
}

Form.buildSpinnersInside = function (selector) {
    $.widget("ui.spinner", $.ui.spinner, {
        _format: function (value) {
            let $elem = $(this.element),
                append = '';

            if ($elem.closest('.js-product-cart').data('spinner-append')) {
                append = $elem.closest('.js-product-cart').data('spinner-append');
            }

            return _.template(Spinner.template)({
                value: value,
                append: append
            });
        },
        _parse: function (value) {
            return parseInt(value);
        }
    });

    $(selector).find('input.ui-spinner').each(function () {
        const $spinner = $(this);

        if (!$spinner.data('uiSpinner')) {
            $(this).spinner(Spinner.options);
        }
    });
}

function handleVariationChange(changedOption)
{
    var $configurator = $('.js-configurator');

    // build the url
    var url = '/produkt-skupiny/' + $configurator.data('groupId') + '?';
    var query = {};

    $configurator.find('select').each(function (i, el) {
        if (!$(el).data('variationId')) {
            return;
        }

        query['variation[' + $(el).data('variationId') + ']'] = $(el).val();
    });

    query['changedVariation'] = $(changedOption).parents('select').data('variationId');
    query['changedVariationValue'] = $(changedOption).val();

    var params = new URLSearchParams(query);
    url += params.toString();

    $.get(url, function (data) {
        if (!data.status && data.msg) {
            Eshop.alert(data.msg, {type: 'error'});

            return;
        }

        window.location = data.url
    })
}

function initializeVariationSelects() {
    $('.product-main__configurator .property').each(function () {
        var $property = $(this);

        if ($property.closest('.property-select').hasClass('hidden')) {
            return true;
        }

        $property.multiselect({
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><div class="sc-square"><b class="caret"></b></div><div class="sc-info"><div class="sc-info__label">&nbsp;</div><div class="multiselect-selected-text"></div></div></button>',
            },
            onChange: function (option, checked, select) {
                var $text = this.$container.find('.multiselect-selected-text'),
                    selectedImage = $(option).data('image');

                if ($(option).data('is-fake-variation')) {
                    handleVariationChange(option);

                    return;
                }

                if ($text.prev('img')) {
                    $text.prev('img').remove();
                }

                if (selectedImage) {
                    $text.before('<img src="' + selectedImage + '" />');
                }
            },
            onInitialized: function (select, container) {
                updatePconInputs($property);
                $('.product-main__configurator .property-select').addClass('is-active');
            },
        });
    });
}

function initializePcon() {
    $('.product-pcon__main .property').each(function () {
        var $property = $(this);

        if ($property.closest('.property-select').hasClass('hidden')) {
            return true;
        }

        $property.multiselect({
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><div class="sc-square"><b class="caret"></b></div><div class="sc-info"><div class="sc-info__label">&nbsp;</div><div class="multiselect-selected-text"></div></div></button>',
            },
            onChange: function (option, checked, select) {
                var $text = this.$container.find('.multiselect-selected-text'),
                    selectedImage = $(option).data('image');

                if ($text.prev('img')) {
                    $text.prev('img').remove();
                }

                if (selectedImage) {
                    $text.before('<img src="' + selectedImage + '" />');
                }

                $('.js-pcon-main').addClass('is-loading');
            },
            onInitialized: function (select, container) {
                updatePconInputs($property);
            },
        });
    });

    $('.js-pcon-main').removeClass('is-loading');

    openLastPcon();
}

function openLastPcon() {
    let $lastOpened = $('.js-pcon-main').find(`.property-select[data-key="${lastOpenedPconKey}"]:visible`);

    if (!$lastOpened.length) {
        $lastOpened = $('.js-pcon-main').find('.property-select:visible').first();
    }

    if ($lastOpened.length) {
        let $main = $('.js-pcon-main').find('.main');

        $lastOpened.addClass('is-active');

        if (checkResolution('cxs;xs')) {
            if ($main.outerWidth() < $lastOpened.offset().left + $lastOpened.outerWidth()) {
                $main.scrollLeft(($lastOpened.offset().left + 20) - $main.outerWidth() / 2);
            }
        } else {
            $main = $('.js-pcon-main');

            if ($main.outerHeight() < $lastOpened.offset().top + $lastOpened.outerHeight()) {
                $main.scrollTop(($lastOpened.offset().top + 20) - $main.outerWidth() / 2);
            }
        }

        return;
    }

    $('.js-pcon-main').find('.property-select:first:visible').addClass('is-active');
}

function updatePconInputs($select) {
    var container = $select.next(),
        $text = $(container).find('.multiselect-selected-text'),
        selectedImage = $select.find(':selected').data('image'),
        $options = $select.find('option');

    if (selectedImage) {
        $text.before('<img src="' + selectedImage + '" />');
    }

    $options.each(function () {
        var inputImage = $(this).data('image'),
            $selectInput = $(container).find('input[value="' + $(this).val() + '"]');

        if (inputImage && !$selectInput.prev().is('img')) {
            $selectInput.closest('label').addClass('has-image');
            $selectInput.before('<img src="' + inputImage + '" />');
        }
    });
}

function updatePconImageSize() {
    if (checkResolution('cxs;xs') && $('.js-product-image').hasClass('has-pcon-open')) {
        const $productImage = $('.js-product-image'),
            $viewer = $productImage.find('#viewer'),
            availableHeight = $productImage.height(),
            availableWidth = $productImage.width();

        if (availableHeight > availableWidth) {
            $viewer.height(availableWidth).width(availableWidth);
        } else {
            $viewer.height(availableHeight).width(availableHeight);
        }
    }
}

function wishlistModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-wishlist-form').validate({
        submitHandler: function (form) {
            $modal.find('[type="submit"]').addClass('is-loading').prop('disabled', true);
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            Form.ajaxPost(form, function (data) {
                $modal.find('[type="submit"]').removeClass('is-loading').prop('disabled', false);

                if (!data.status) {
                    $('.js-wishlist-error')
                        .text(data.message)
                        .slideDown(200);
                } else {
                    $('.js-wishlist-success')
                        .text(data.message)
                        .slideDown(200);
                    $('.js-wishlist-hide').slideUp(200);
                }
            }, 'json');
        }
    });

    $('.js-new-wishlist-form').validate({
        submitHandler: function (form) {
            $modal.find('[type="submit"]').addClass('is-loading').prop('disabled', true);
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            Form.ajaxPost(form, function (data) {
                $modal.find('[type="submit"]').removeClass('is-loading').prop('disabled', false);

                if (!data.status) {
                    $('.js-wishlist-error')
                        .text(data.message)
                        .slideDown(200);
                } else {
                    $('.js-wishlist-success')
                        .text(data.message)
                        .slideDown(200);
                    $('.js-wishlist-hide').slideUp(200);
                }
            }, 'json');
        }
    });
}

if (Url.getParameter('openConfigurator') && !$('.js-custom-not-saleable').length && $('.js-target-pcon').length) {
    freezeScroll();
    $('.c-overlay--pcon').addClass('is-active');
    $('body').addClass('is-overlayed');

    $(window).scrollTop(0);

    $(window).on('beforeunload', function () {
        $(window).scrollTop(0);
    });
};

function showPcon() {
    if ($('#viewer').length) {
        $('#viewer').removeClass('is-hidden');
        $('.js-main-image, .product-gallery').addClass('is-hidden');
    }

    $('#product-container .js-product-main-name').addClass('can-be-updated');

    $('.js-target-pcon').addClass('is-open');
    $('.js-product-image').addClass('has-pcon-open');

    $(window).scrollTop(0);

    freezeScroll();
    $('.c-overlay--pcon').addClass('is-active');
    $('body').addClass('is-overlayed');

    updatePconImageSize();
    openLastPcon();
}

function hidePcon() {
    if ($('#viewer').length) {
        $('#viewer').removeClass('has-pcon-overlay');
    }

    $('.js-target-pcon').removeClass('is-open');
    $('.js-product-image').removeClass('has-pcon-open');

    unfreezeScroll();
    $('.c-overlay--pcon').removeClass('is-active');
    $('body').removeClass('is-overlayed');

    bLazy.revalidate();
}

$(function () {
    checkSliders(swipers);
    initializeVariationSelects();

    if (Url.getParameter('openConfigurator') && !$('.js-custom-not-saleable').length && $('.js-target-pcon').length) {
        showPcon();
    };

    $('.js-description-scroll').on('click', function (e) {
        e.preventDefault();

        $('.js-product-tabs-item.is-description').find('.c-link').trigger('click');

        $('.js-product-tabs-nav').slideHere(20, 300);
    });

    $('.js-product-collapse-content').each(function () {
        const $collapse = $(this);

        $collapse.shorten({
            showChars: parseInt($collapse.data('show-chars')),
            moreText: $collapse.data('more-text'),
            ellipsesText: '<strong> ...</strong>',
            removeTags: !$collapse.data('keep-tags')
        });
    });

    $("a[data-toggle=\"tab\"]").on("shown.bs.tab", function (e) {
        bLazy.revalidate();
    });

    $('.js-lightbox-wrapper').lightGallery(
        $.extend({}, lightGallerySettings, {
            thumbnail: true,
            selector: '.js-lightbox',
            exThumbImage: 'data-thumb',
            galleryId: 1
        })
    );

    $('.js-lightbox-wrapper').on('onBeforeOpen.lg', function () {
        freezeScroll();
    });

    $('.js-lightbox-wrapper').on('onCloseAfter.lg', function () {
        unfreezeScroll();
    });

    $('.js-gallery-more').on('click', function (e) {
        e.preventDefault();

        $('.js-lightbox-wrapper').find('.product-gallery__item').eq(parseInt($(this).data('eq')) || 0).find('.js-lightbox').trigger('click');
    });

    $(document).on('click', '.js-tabs-trigger', function () {
        activeOfferTippyInstance.popperInstance.update();
    });

    $('.js-main-image').on('click', function (e) {
        e.preventDefault();

        $('.js-lightbox-wrapper .product-gallery__item:not(.is-video)').eq(0).find('.js-lightbox').trigger('click');
    });

    tippy('.js-price-offer-trigger', {
        html: '.js-price-offer-target',
        distance: 15,
        arrow: false,
        animation: 'shift-away',
        duration: [300, 180],
        inertia: true,
        performance: true,
        placement: "top-end",
        interactive: true,
        trigger: 'click',
        animateFill: false,
        theme: 'price-offer',
        onShow() {
            const $template = $('.js-price-offer-trigger').next('.js-price-offer-target');
            const moduleData = $('#productCart input[name="module_data"]').val();

            if ($template.length) {
                $template.remove();
            }

            setTimeout(() => {
                const $tabs = $('.js-offer-tabs');

                if (!$tabs.hasClass('tabs-are-active')) {
                    $tabs.rTabs();
                }

                $('.js-price-offer-form').find('.js-price-offers-multiselect').removeClass('is-loaded');
                $('.js-price-offer-form input[name="module_data"]').val(moduleData);

                renderMultiselect();
            }, 1);
        }
    });

    $(document).on('click', '.js-price-offer-close', function () {
        if (!activeOfferTippyInstance) {
            return;
        }

        activeOfferTippyInstance.hide();

        activeOfferTippyInstance = null;
    });

    $(document).on('submit', '.js-price-offer-form', function (e) {
        e.preventDefault();

        const $form = $(this),
            $submit = $form.find('.js-price-offer-form-submit'),
            $msg = $form.find('.js-price-offer-form-msg'),
            popperInstance = activeOfferTippyInstance.popperInstance;

        $msg.hide();
        if (popperInstance) {
            popperInstance.update();
        }

        $submit.addClass('is-loading').prop('disabled', true);

        $.post($form.attr('action'), $form.serialize(), function (data) {
            $submit.removeClass('is-loading').prop('disabled', false);

            $msg.html(data.message);
            $msg.toggleClass('c-msg--error', !data.status);
            $msg.toggleClass('c-msg--success', data.status);
            $msg.show();
            if (popperInstance) {
                popperInstance.update();
            }
        }, 'json').fail(function () {
            $submit.removeClass('is-loading').prop('disabled', false);

            $msg.html($msg.data('error'));
            $msg.toggleClass('c-msg--error', true);
            $msg.toggleClass('c-msg--success', false);
            $msg.show();

            if (activeOfferTippyInstance.popperInstance) {
                activeOfferTippyInstance.popperInstance.update();
            }
        });
    });

    $('.js-product-image:not(.has-pcon-open) #viewer.has-pcon-overlay').one('click', function () {
        $(this).removeClass('has-pcon-overlay');
    });

    $(document).on('focus', 'input.ui-spinner-input', function () {
        $(this).val(parseInt($(this).val()));
    });

    $(document).on('spinchange blur', 'input.ui-spinner-input', function (e, ui) {
        const $spinnerInput = $(this),
            max = parseInt($spinnerInput.attr('max')),
            min = parseInt($spinnerInput.attr('min')),
            step = $spinnerInput.spinner('option', 'step');

        let value = parseInt($spinnerInput.val()),
            append = '';

        if ($spinnerInput.closest('.js-product-cart').data('spinner-append')) {
            append = $spinnerInput.closest('.js-product-cart').data('spinner-append');
        }

        if (value > max) {
            value = max;
        }

        if (value < min) {
            if (step && min < step) {
                value = step;
            } else {
                value = min;
            }
        }

        $spinnerInput.val(_.template(Spinner.template)({
            value: value,
            append: append
        }));
    });

    $('.js-share-pcon').on('click', function() {
        // if native share is available share natively url. If not, copy it to clipboard
        if (navigator.share) {
            navigator.share({
                title: document.title,
                url: window.location.href
            })
            .catch((error) => {
                if (error.toString().includes('AbortError')) return

                Eshop.alert(error, {type: 'error'});
                console.error(error)
            });
        } else {
            navigator.clipboard.writeText(window.location.href).then(() => {
                Eshop.alert('Odkaz na konfigurátor bol skopírovaný.', {type: 'success'});
            });
        }
    })

    //--------- PCON ---------//
    if (document.getElementById("product-container")) {
        document.getElementById("product-container").addEventListener("loaded", function (e) {
            $('.js-product-image').find('#viewer').removeClass('is-loading');

            if (pConLoadedTimeout) {
                clearTimeout(pConLoadedTimeout);
            }

            pConLoadedTimeout = setTimeout(function () {
                initializePcon();
            }, 2000);
        });

        document.getElementById("product-container").addEventListener("property.created", function (e) {
            if (pConLoadedTimeout) {
                clearTimeout(pConLoadedTimeout);
            }

            pConLoadedTimeout = setTimeout(function () {
                initializePcon();
            }, 300);
        });

        document.getElementById("product-container").addEventListener("property.changed", function (e) {
            var moduleData = $('#productCart').find('input[name="module_data"]').size() ? $('#productCart').find('input[name="module_data"]').val() : false;

            moduleData = moduleData ? JSON.parse(moduleData) : {};
            var pconProps = moduleData['pcon_properties'] ? moduleData['pcon_properties'] : {};

            pconProps[e.detail.propName] = e.detail;
            Cart.moduleData('#productCart input[name="module_data"]', 'pcon_properties', pconProps);
            Cart.moduleData('.product-pcon__buy input[name="module_data"]', 'pcon_properties', pconProps);

            const params = new URLSearchParams({
                'pcon_properties': JSON.stringify(pconProps)
            }).toString();

            const url = new URL(window.location.href);
            url.search = params;

            window.history.replaceState({}, '', url);
        });

        document.getElementById("product-container").addEventListener("product.changed", function (e) {
            var price = e.detail.price,
                oldPrice = e.detail.price,
                shortTextName = $('#product-container').data('shorttext');

            if (productDiscount != undefined && productDiscount > 0) {
                price -= (price / 100) * productDiscount;
            }

            var priceWithoutVat = price;

            if (Eshop.options.pricesWithVat) {
                price *= 1.23;
                oldPrice *= 1.23;
            }

            $('.js-pcon-props-model').html(e.detail.model);

            $('#product-container .js-product-main-name.can-be-updated').html(shortTextName ? e.detail.short_text : e.detail.name);
            $('.js-pcon-props-name').html(shortTextName ? e.detail.short_text : e.detail.name);

            $(`#product-container .product-main__pricing [data-element="cartItem"][data-type="price${Eshop.options.pricesWithVat ? 'Vat' : ''}"]`).html(Format.price(price));
            $(`.product-pcon__wrapper [data-element="cartItem"][data-type="price${Eshop.options.pricesWithVat ? 'Vat' : ''}"]`).html(Format.price(price));
            $(`#product-container .product-main__pricing [data-element="cartItem"][data-type="oldPrice${Eshop.options.pricesWithVat ? 'Vat' : ''}"]`).html(Format.price(oldPrice));
            $(`.product-pcon__wrapper [data-element="cartItem"][data-type="oldPrice${Eshop.options.pricesWithVat ? 'Vat' : ''}"]`).html(Format.price(oldPrice));

            $(`#product-container .product-main__pricing [data-element="cartItem"][data-type="price"]`).html(Format.price(priceWithoutVat));
        });

        $('.js-trigger-pcon').on('click', function () {
            showPcon();
        });

        $('.js-close-pcon').on('click', function () {
            hidePcon();
        });

        $('.js-pcon-center').on('click', function () {
            if (typeof app !== 'undefined') {
                app.mViewerUI.zoomToFitElements();
            }
        });

        $('body').on('click', function (event) {
            if ($('.js-target-pcon').hasClass('is-open')) {
                const $target = $(event.target);

                if ($target.closest($('.l-header')).length) {
                    hidePcon();
                }
            }
        });

        $('.js-pcon-main').on('click', '.property-select', function () {
            $('.js-pcon-main').find('.property-select').removeClass('is-active');

            lastOpenedPconKey = $(this).data('key');

            $(this).addClass('is-active');
        });

        rEvent.on('Window.resized', function () {
            updatePconImageSize();
        });

        $('.c-overlay.is-pcon').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });

        $('.js-price-offer-trigger').on('click', function () {
            activeOfferTippyInstance = this._tippy;
        });
    }

    $("[name=\"productQuestionForm\"]").on('submit', function (e) {
        e.preventDefault();
    });

    $("[name=\"productQuestionForm\"]").validate({
        rules: {
            "email": {
                email: true
            }
        },
        submitHandler: function (form) {
            const $form = $(form);
            $form.find('[type="submit"]').prop('disabled', true).addClass('is-loading');

            $.post($form.attr('data-url'), $form.serialize(), function (data) {
                $form.find('[type="submit"]').prop('disabled', true).addClass('is-loading');

                console.log(data);

                if (!data.status) {
                    Eshop.alert(data.message, {
                        type: 'error'
                    });
                } else {
                    Eshop.alert(data.message, {
                        type: 'success'
                    });

                    $('#product-question-modal').modal('hide');
                }
            }, 'json').fail(function (err) {
                Eshop.alert(err.statusText, {
                    type: 'error'
                });

                $form.find('[type="submit"]').prop('disabled', false).removeClass('is-loading');
            });

            // var elemClass = data.status ? "alert alert-success" : "alert alert-danger";

            // if (data.status) {
            //     $form.fadeOut();
            // }

            // $("#questionMessage")
            //     .html(data.message)
            //     .removeClass("is-hidden")
            //     .removeClass("alert-success")
            //     .removeClass("alert-danger")
            //     .addClass(elemClass);
        }
    });
});
